import { ReactNode } from 'react'

interface ComboBoxIconProps {
  icon: ReactNode
}

const ComboBoxIcon = ({ icon }: ComboBoxIconProps) => (
  <span role="img">{icon}</span>
)

export default ComboBoxIcon
